import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Truck, Map, DollarSign, User } from 'lucide-react';
import { useTracking } from '../context/TrackingContext';

// No longer takes trackingActive as a prop — reads it directly from
// TrackingContext, so every screen's BottomTabBar automatically reflects
// real tracking state, regardless of which tab is currently showing.
function BottomTabBar() {
  const { t } = useTranslation();
  const { trackingEnabled } = useTracking();

  const tabs = [
    { to: '/loads', label: t('nav.loads'), icon: Truck },
    { to: '/map', label: t('nav.map'), icon: Map, showPulse: trackingEnabled },
    { to: '/payments', label: t('nav.payments'), icon: DollarSign },
    { to: '/profile', label: t('nav.profile'), icon: User },
  ];

  return (
    <nav style={styles.nav}>
      {tabs.map(({ to, label, icon: Icon, showPulse }) => (
        <NavLink
          key={to}
          to={to}
          style={({ isActive }) => ({
            ...styles.tabItem,
            color: isActive ? '#2563eb' : '#9ca3af',
            fontWeight: isActive ? 600 : 400,
          })}
        >
          <div style={{ position: 'relative' }}>
            <Icon size={22} />
            {showPulse && <span style={styles.pulseDot} />}
          </div>
          <span style={{ marginTop: 4 }}>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

const styles = {
 nav: {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'white',
  boxShadow: '0 -1px 6px rgba(0,0,0,0.08)',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  minHeight: 64,
  paddingTop: 8,
  paddingBottom: 'calc(env(safe-area-inset-bottom) + 8px)',
  zIndex: 50,
},
  tabItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: 12,
    textDecoration: 'none',
  },
  pulseDot: {
    position: 'absolute',
    top: -2,
    right: -4,
    width: 9,
    height: 9,
    borderRadius: '50%',
    backgroundColor: '#059669',
    animation: 'pulse 1.5s ease-in-out infinite',
    border: '1.5px solid white',
  },
};

export default BottomTabBar;